import axios from 'axios'
import Qs from 'qs'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
const formatParams = params => {
  // 过滤空值
  Object.keys(params).map(key => {
    if (params[key] === '' || params[key] === null) {
      delete params[key]
    }
  })

  return params
}

const formatData = data => {
  // 过滤空值
  Object.keys(data).map(key => {
    if (data[key] === undefined || data[key] === null) {
      delete data[key]
    }
  })

  return data
}

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 120 * 1000, // request timeout
  paramsSerializer: function(params) {
    return Qs.stringify(formatParams(params), { arrayFormat: 'brackets' })
  }
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (config.data) {
      config.data = formatData(config.data)
    }
    // do something before request is sent
    config.withCredentials = true
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      /*  config.params = {
        ...config.params,
        token: getToken()
      } */
      config.headers['Authorization'] = 'Bearer ' + getToken()
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data

    // code 不是0 则是错误
    if (res.code !== 0) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // to re-login
        MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    if (String(error).includes('timeout')) {
      Message({
        message: `网络等待超过最大时间！`,
        type: 'error',
        duration: 5 * 1000
      })
    } else {
      Message({
        message: `网络拥堵，请稍后再试！`,
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service
